export default __webpack_public_path__ + "static/media/film.c05cbf6d.svg";